import { render, staticRenderFns } from "./CoPoll.vue?vue&type=template&id=5478b5e0&scoped=true&"
import script from "./CoPoll.vue?vue&type=script&lang=ts&"
export * from "./CoPoll.vue?vue&type=script&lang=ts&"
import style0 from "./CoPoll.vue?vue&type=style&index=0&id=5478b5e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478b5e0",
  null
  
)

export default component.exports